// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutPage_container__1bu6d"};